import { render } from "./2024.vue?vue&type=template&id=1d4bca9e&scoped=true"
import script from "./2024.vue?vue&type=script&lang=js"
export * from "./2024.vue?vue&type=script&lang=js"

import "./2024.vue?vue&type=style&index=0&id=1d4bca9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4bca9e"]])

export default __exports__